import { render, staticRenderFns } from "./BizInsuranceDataInvoiceForm.vue?vue&type=template&id=8e63a378&scoped=true&"
import script from "./BizInsuranceDataInvoiceForm.vue?vue&type=script&lang=js&"
export * from "./BizInsuranceDataInvoiceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e63a378",
  null
  
)

export default component.exports